<template>
    <div >   
        <!-- //DIALOGS -->
        <div>
            <!----------- RECEIVE STOCKS ------------->
            <v-dialog
                v-model="dialog_receive_stocks"
                scrollable   
                :persistent="true" :overlay="false"
                max-width="1000px"
                transition="dialog-transition" >
                <v-card rounded="lg" v-if="dialog_receive_stocks"> 
                    <v-card-title class="primary">
                        <div class="font-weight-bold b2--text"><v-icon dark large>mdi-package-down</v-icon> INVENTORY RECEIVING CONSOLE</div> 
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="CONFIRM_CANCELING_RECEIVE_STOCK()"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-title>
                    <v-card flat class="mbs-scroll-y"  :height="''">  
                        <template>
                            <v-stepper
                                v-model="receive_step"
                                vertical >
                                <!-- //----------------[STEP1]------------------>
                                <v-stepper-step
                                    :complete="receive_step > 1"
                                    step="1">
                                    Select Type
                                    <small>Document type to process incoming stock</small>
                                </v-stepper-step>
                                <form id="steps1" @submit.prevent="NEXT_STEP(2,input)" >
                                    <v-stepper-content step="1">
                                        <v-card
                                            outlined
                                            class="px-5 pt-7 pb-9 mb-2"
                                            height="">
                                            <mbs-input-fields
                                                v-model="input"
                                                :name_items="NAME_ITEMS"
                                                :name_item="NAME_ITEM"
                                                :value_items="VALUE_ITEMS"
                                                :value_item="VALUE_ITEM"
                                                :field_items="ReceiveOptionField"
                                                :select_items="Selectors"
                                                :disabled_fields="null"
                                                />   
                                        </v-card>
                                        <v-btn type="submit"
                                            color="primary" >
                                            Continue
                                        </v-btn>
                                        <v-btn text @click="CONFIRM_CANCELING_RECEIVE_STOCK()">
                                            Cancel
                                        </v-btn>
                                    </v-stepper-content>
                                </form>

                                <!-- //----------------[STEP2]------------------>
                                <v-stepper-step
                                    :complete="receive_step > 2"
                                    step="2">
                                    Select document
                                    <small v-if="SelectedStockOption">{{ SelectedStockOption?.description }}</small>
                                </v-stepper-step>
                                <form id="steps2" @submit.prevent="NEXT_STEP(3,input)" >
                                    <v-stepper-content step="2">
                                        <v-card
                                            outlined
                                            class="px-5 pt-7 pb-9 mb-2"
                                            height="">
                                            <mbs-input-fields
                                                v-model="input"
                                                :name_items="NAME_ITEMS"
                                                :name_item="NAME_ITEM"
                                                :value_items="VALUE_ITEMS"
                                                :value_item="VALUE_ITEM"
                                                :field_items="DocumentReceiptsField"
                                                :select_items="Selectors"
                                                :disabled_fields="null"
                                                />   
                                              <!-- <mbs-item-manager
                                                :table_title=" SelectedStockOption?.description"
                                                :table_title_icon=" SelectedStockOption?.icon"
                                                :add_vertical_lines="true"
                                                :row_click="true" 
                                                :top_label="false"
                                                :filter_date="false"
                                                :filter_date_value="'created_at'"
                                                :filter_default_days="'90'"
                                                :name_items=" SelectedStockOption?.name"
                                                :name_item="NAME_ITEM"
                                                :value_items="VALUE_ITEMS"
                                                :value_item="VALUE_ITEM" 
                                                :header_items="HEADER_ITEMS" 
                                                :data_items="StockDocumentTypeData"   
                                                :is_joined="true"   
                                                />
                                                -->
                                        </v-card>
                                        <v-btn type="submit"
                                            color="primary" >
                                            Continue
                                        </v-btn>
                                        <v-btn @click="NEXT_STEP(1)">
                                            Back
                                        </v-btn>
                                    </v-stepper-content>
                                </form>

                                <!-- //----------------[STEP3]------------------>
                                <v-stepper-step
                                    :complete="receive_step > 3"
                                    step="3">
                                    Select Incoming Stock Items
                                    <!-- <small>{{ SelectedStockOption?.name }}</small> -->
                                </v-stepper-step>
                                <form id="steps3" @submit.prevent="NEXT_STEP(4,input)" >
                                    <v-stepper-content step="3">
                                        <v-card-title class="primary">
                                            <v-layout row wrap  align-center  class="pt-2 px-5">
                                                <v-layout row wrap class="ma-0"> 
                                                    <div class="font-weight-bold b2--text">
                                                        <v-icon dark >mdi-tag</v-icon> STOCK ITEMS
                                                    </div> 
                                                    <v-autocomplete   class="ml-2 mt-" dark  
                                                        :label="'Search item'" 
                                                        append-icon="mdi-magnify" 
                                                        clearable  
                                                        filled dense
                                                        rounded :disabled="!edit_selected_items"
                                                        :items="InventoryItems"
                                                        :item-text="'name'"
                                                        item-value="key"
                                                        outlined
                                                        v-model="search_item"
                                                        :filter="(item, queryText, itemText) => { 
                                                            let index = (a,b)=>{
                                                                    if(!a||!b){return false}
                                                                    a = ''+a; b = ''+b
                                                                    return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                                                                } 
                                                                let first = index(itemText,queryText)
                                                                let second = item?index(item.code,queryText):false
                                                                let third = item?index(item.brand_name,queryText):false
                                                                let forth = item?index(item.category_name,queryText):false
                                                                if(!item){return first}  
                                                                return first || second || third || forth 
                                                        }"
                                                        >
                                                        <template v-slot:selection="data">
                                                            {{ data.item.name }}
                                                        </template>
                                                        <template v-slot:item="data">
                                                            <template v-if="(typeof data.item !=='object')" >
                                                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                                            </template>
                                                            <template v-else>
                                                                <v-list-item-avatar tile color="grey" >
                                                                    <img :src="data.item.image" v-if="data.item.image">
                                                                    <v-icon v-else>local_offer</v-icon>
                                                                </v-list-item-avatar>
                                                                <v-list-item-content >
                                                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                                                    <v-list-item-subtitle v-html="data.item.code_"></v-list-item-subtitle>
                                                                    <v-list-item-subtitle v-html="data.item.category_name"></v-list-item-subtitle>
                                                                    <v-list-item-subtitle v-html="data.item.brand_name"></v-list-item-subtitle>
                                                                </v-list-item-content>
                                                                <v-list-item-action>
                                                                    <div class=" font-weight-bold"> 
                                                                        <small> Stock</small> {{data.item[from_outlet_code+"_number_quantity"]}}
                                                                    </div> 
                                                                </v-list-item-action> 
                                                            </template>
                                                        </template>
                                                    </v-autocomplete>  
                                                </v-layout>                                               
                                                <v-layout row wrap class="ma-0 pl-3">
                                                    <v-spacer></v-spacer>
                                                    <v-menu  
                                                        v-model="menu_outlet" 
                                                        :close-on-content-click="false" 
                                                        offset-y  offset-overflow
                                                        :nudge-width="90" rounded="xl"> 
                                                        <template v-slot:activator="{ on }">    
                                                            <v-btn :disabled="
                                                                    !(SelectedStockOption?.key == 'new_record' || 
                                                                    SelectedStockOption?.key == 'drafts')
                                                                "
                                                                small tile  v-on="on" dark
                                                                :loading="inputLoading" 
                                                                class="ml-1 mb-1 "  color="secondary"  >
                                                                <v-icon class="mr-2">{{SelectedOutlet?SelectedOutlet.icon:'mdi-sitemap'}}</v-icon>
                                                                <div class="not-f font-weight-bold">{{SelectedOutlet?SelectedOutlet.name:'Select outlet'}}</div>  
                                                                <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                                            </v-btn> 
                                                        </template>  
                                                        <v-card>
                                                            <v-card-title primary-title class="secondary white--text">
                                                                Select Outlet
                                                            </v-card-title>
                                                            <v-list >
                                                                <v-list-item @click="SET_OUTLET(outlet.code)"
                                                                    v-for="(outlet,index) in StockOutletsData" 
                                                                    :key="index" >
                                                                    <v-list-item-avatar><v-icon>{{ outlet.icon }}</v-icon></v-list-item-avatar>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>{{outlet.name}}</v-list-item-title>
                                                                        <v-list-item-subtitle>{{outlet.outlet_type_name}}</v-list-item-subtitle>
                                                                    </v-list-item-content> 
                                                                </v-list-item>   
                                                            </v-list>
                                                        </v-card>
                                                    </v-menu> 
                                                    <v-menu  
                                                        v-model="menu_excel" 
                                                        :close-on-content-click="false" 
                                                        offset-y  offset-overflow
                                                        :nudge-width="90" rounded="xl"> 
                                                        <template v-slot:activator="{ on }">    
                                                            <v-btn small tile  v-on="on" dark
                                                                :loading="inputLoading" :disabled="!edit_selected_items"
                                                                class="ml-1 mb-1"  color="secondary"  >
                                                                <v-icon>mdi-microsoft-excel</v-icon>
                                                                <div class="not-f font-weight-bold">Excel</div>  
                                                                <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                                            </v-btn> 
                                                        </template>  
                                                        <v-card>
                                                            <v-card-title primary-title class="secondary white--text">
                                                                Select outlet
                                                            </v-card-title>
                                                            <v-list>
                                                                <v-list-item @click="ON_SUBMIT_SOCK_RECEIVE('direct_receive')">
                                                                    Direct Receive
                                                                </v-list-item>  
                                                                <v-list-item @click="ON_SUBMIT_SOCK_RECEIVE('save_draft')">
                                                                    Save Draft
                                                                </v-list-item> 
                                                                <v-list-item @click="ON_SUBMIT_SOCK_RECEIVE('back')">
                                                                    Back
                                                                </v-list-item> 
                                                                <v-list-item @click="ON_SUBMIT_SOCK_RECEIVE('cancel')">
                                                                    Cancel
                                                                </v-list-item> 
                                                            </v-list>
                                                        </v-card>
                                                    </v-menu> 
                                                    <v-btn v-if="selected_items" dark :disabled="!edit_selected_items" class="ml-1 mb-1" tile small color="error" @click="CONFIRM_CLEAR_SELECTED_ITEMS()">
                                                        Clear
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn> 
                                                </v-layout> 
                                            </v-layout>
                                        </v-card-title>
                                        <v-card
                                            outlined
                                            class="px-5 pt-7 pb-9 mb-2"
                                            height="">
                                            <mbs-stock-receive-selected-items
                                                v-model="input_receive"
                                                :edit_selected_items="!edit_selected_items"
                                                :height="(vsh-600)" 
                                                :to_outlet_code="selected_outlet_code"  
                                                :from_outlet_code="from_outlet_code"
                                                @selected_items="selected_items=$event"  
                                            />   
                                        </v-card>
                                        <v-btn type="submit"
                                            color="primary" >
                                            Continue
                                        </v-btn>
                                        <v-btn @click="NEXT_STEP(2)">
                                            Back
                                        </v-btn>
                                    </v-stepper-content>
                                </form>
                                
                                <!-- //----------------[STEP4]------------------>
                                <v-stepper-step
                                    :complete="receive_step > 4"
                                    step="4">
                                    Process Incoming Goods Receipt
                                    <small>{{ SelectedStockOption?.name }}</small>
                                </v-stepper-step>
                                <form id="steps4" @submit.prevent="CONFIRM_SUBMIT_STOCK_RECEIVE(input_receive,receive_option)" >
                                    <v-stepper-content step="4">
                                        <v-card-title class="primary">
                                            <v-layout row wrap   align-center  class="pt-2 px-5">
                                                <div class="font-weight-bold b2--text">
                                                    <v-icon dark >mdi-information</v-icon> GOODS RECEIVING DETAILS
                                                </div>  
                                                <v-spacer></v-spacer>
                                                <v-btn   class="mr-2" tile small color="secondary" @click="NEXT_STEP(3)">
                                                    Step Back 
                                                </v-btn>
                                            </v-layout>
                                        </v-card-title>
                                        <v-card v-if="receive_step==4"
                                            outlined
                                            class="px-5 pt-7 pb-9 mb-2"
                                            height=""> 
                                            <mbs-input-fields
                                                v-model="input_receive"
                                                :name_items="NAME_ITEMS"
                                                :name_item="NAME_ITEM"
                                                :value_items="VALUE_ITEMS"
                                                :value_item="VALUE_ITEM"
                                                :field_items="DATA.FIELDS.receive_selected_stocks"
                                                :select_items="Selectors"
                                                :update_item="SelectedStockOption?.key =='requests' || SelectedStockOption?.key =='drafts'"
                                                :disabled_fields="disabled_fields"
                                                />  
                                        </v-card> 
                                        <v-layout  class="ma-0" align-center> 
                                            <v-flex> 
                                                <v-btn v-if="SelectedStockOption?.key !='requests'"
                                                    @click="ON_SUBMIT_SOCK_RECEIVE('send_for_approval')"
                                                    class="px- m" large color="primary" width="100%" >SEND FOR APPROVAL</v-btn>
                                                <v-btn v-if="SelectedStockOption?.key =='requests'"
                                                    @click="ON_SUBMIT_SOCK_RECEIVE('approve_request')"
                                                    class="px- m" large color="primary" width="100%" >APPROVE & RECEIVE REQUEST</v-btn>
                                            </v-flex> 
                                            <v-flex xs3> 
                                                <v-menu  
                                                    v-model="menu_transfer_option" 
                                                    :close-on-content-click="false" 
                                                    offset-y  offset-overflow
                                                    :nudge-width="90" rounded="xl">

                                                    <template v-slot:activator="{ on }">   
                                                        
                                                        <v-btn large  v-show="false" type="submit"
                                                            :loading="inputLoading" ref="ref_btn_receive_stock"
                                                            class="mt-3 "  color="secondary" height="60" width="99%">
                                                            <div class="not-f5">Transfer Options</div>  
                                                            <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                                        </v-btn> 
                                                        <v-btn large  v-on="on"
                                                            :loading="inputLoading" 
                                                            class="ml-1 "  color="secondary" width="99%">
                                                            <div class="not-f5">More Options</div>  
                                                            <v-icon class="ml-1 mr-1">arrow_drop_down</v-icon>
                                                        </v-btn> 
                                                    </template>  
                                                    <v-card>
                                                        <v-card-title primary-title class="secondary white--text">
                                                            More Option
                                                        </v-card-title>
                                                        <v-list >
                                                            <!-- // -->
                                                            <v-list-item v-if="SelectedStockOption?.key !='requests'"
                                                                @click="ON_SUBMIT_SOCK_RECEIVE('direct_receive')">
                                                                Direct Receive
                                                            </v-list-item>  
                                                            <v-list-item v-if="SelectedStockOption?.key =='new_record'" 
                                                                @click="ON_SUBMIT_SOCK_RECEIVE('save_draft')">
                                                                Save Draft
                                                            </v-list-item> 
                                                            <!-- // -->
                                                             <v-list-item v-if="SelectedStockOption?.key =='drafts'" 
                                                                @click="ON_SUBMIT_SOCK_RECEIVE('save_draft')">
                                                                Update Draft
                                                            </v-list-item> 
                                                            <!-- // -->
                                                            <v-list-item v-if="SelectedStockOption?.key =='requests'"
                                                                @click="ON_SUBMIT_SOCK_RECEIVE('approve_request')">
                                                                Approve & Receive
                                                            </v-list-item>  
                                                            <v-list-item v-if="SelectedStockOption?.key =='requests'"
                                                                @click="ON_SUBMIT_SOCK_RECEIVE('cancel_request')">
                                                                Cancel Request
                                                            </v-list-item>  

                                                            <!-- // -->
                                                            <v-list-item @click="NEXT_STEP(3)">
                                                                Back
                                                            </v-list-item> 
                                                            <v-list-item @click="CONFIRM_CANCELING_RECEIVE_STOCK()">
                                                                Cancel
                                                            </v-list-item> 
                                                        </v-list>
                                                    </v-card>
                                                </v-menu>  
                                            </v-flex>
                                        </v-layout>
                                    </v-stepper-content>
                                </form>
                            </v-stepper>
                        </template> 
                    </v-card>   
                </v-card>  
            </v-dialog>
  
        </div>
    </div>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex" 
    import DB from "../../../plugins/DB";
    const PAGE_NAME = "SELECT_ITEMS"

    export default {
        props:['from_outlet_code','to_outlet_code','outlets','items',],
        data(){
            return{
                show:false,   
                edit_selected_items:true,   
                dialog_receive_stocks:false,    
                menu_transfer_option:false,  
                menu_outlet:false,  
                menu_excel:false,  
                inputLoading:false,
                search_item:null,
                selected_item:null,
                selected_items:null,
                selected_outlet_code:null,
                receive_option:null, 
                disabled_fields:null, 
                input:{}, 
                input_receive:{}, 
                DATA,
                NAME_ITEMS:DATA.ITEMS.ITEMS.names,
                NAME_ITEM:DATA.ITEMS.ITEMS.name,
                VALUE_ITEMS:DATA.ITEMS.ITEMS.values,
                VALUE_ITEM:DATA.ITEMS.ITEMS.value, 
                receive_stock_type_key:null, 
                receive_step: 1,
                receive_payload:null
            }
        },
        created(){ 
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);   
                this.MBS.events.$on('ON_QR_SCAN', this.ON_QR_SCAN);   
                this.MBS.events.$on('MBS_KEYBOARD', this.MBS_KEYBOARD);  
                this.MBS.events.$on('INVENTORY_STOCK_RECEIVE', this.INVENTORY_STOCK_RECEIVE);  
                this.SET_OUTLET()
                
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){   
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint 
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            },
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'], 
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                 Suppliers: state=> state.items[(DATA.ITEMS.SUPPLIERS.values).toUpperCase()],
                JoinedSuppliers: state=> state.join[(DATA.ITEMS.SUPPLIERS.values).toUpperCase()],

                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                StockReceiveTypes: state=> state.app['STOCK_RECEIVE_TYPES'],  
                StockReceiveOptions: state=> state.app['STOCK_RECEIVE_OPTIONS'],  
                PaymentMethods: state=> state.items[(DATA.ITEMS.PAYMENT_METHODS.values).toUpperCase()],
                JoinedPaymentMethods: state=> state.join[(DATA.ITEMS.PAYMENT_METHODS.values).toUpperCase()],
                DefaultPaymentMethod: state=> state.app[(DATA.ITEMS.DEFAULT_PAYMENT_METHODS.values).toUpperCase()],
                DefaultBillAccount: state=> state.app[(DATA.ITEMS.DEFAULT_BILL_METHODS.values).toUpperCase()], 

                StockOrders: state=> state.items[(DATA.ITEMS.STOCK_ORDERS.values).toUpperCase()],
                JoinedStockOrders: state=> state.join[(DATA.ITEMS.STOCK_ORDERS.values).toUpperCase()], 
                StockRequests: state=> state.items[(DATA.ITEMS.STOCK_REQUESTS.values).toUpperCase()],
                JoinedStockRequests: state=> state.join[(DATA.ITEMS.STOCK_REQUESTS.values).toUpperCase()],
                StockDrafts: state=> state.items[(DATA.ITEMS.STOCK_DRAFTS.values).toUpperCase()],
                JoinedStockDrafts: state=> state.join[(DATA.ITEMS.STOCK_DRAFTS.values).toUpperCase()], 
                QuotationsAndInvoices: state=> state.items[(DATA.ITEMS.QUOTATIONS_AND_INVOICES.values).toUpperCase()],
                JoinedQuotationsAndInvoices: state=> state.join[(DATA.ITEMS.QUOTATIONS_AND_INVOICES.values).toUpperCase()],
            }), 
            StockOutletsData(){ 
                let items = this.JoinedStockOutlets?this.JoinedStockOutlets:this.StockOutlets 
                return items
            }, 
            ToOutlets(){
                const outlets = this.StockOutlets
                const outlet_code = this.from_outlet_code
                return outlets?.filter(item=>item.code !=outlet_code)
            },
            SelectedOutlet(){
                const outlet_code = this.selected_outlet_code
                const outlets = this.StockOutletsData
                return outlets?.find(item=>item.code == outlet_code)
            },
            ItemsData(){ 
                let Items = this.Items
                let JoinedItems = this.JoinedItems
                let CalculatedItems = this.CalculatedItems 
                if (JoinedItems) {
                    return JoinedItems
                } 
                return Items
            },
            InventoryItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const child = item.item_type_key == "child"
                    const parent = item.item_type_key == "parent"
                    const inventory_item_code = item?.inventory_item_code
                    const inventory_item_key = item?.inventory_item_key
                    const inventory_item_keycode = inventory_item_key?inventory_item_key:inventory_item_code
                    const inventory = !inventory_item_keycode || inventory_item_keycode == "main"?true:false
                    return inventory && !service && !child && !parent
                })  
                return filtered
            },
            StockOrdersData(){ 
                const StockOrders = this.StockOrders 
                const JoinedStockOrders = this.JoinedStockOrders
                const items = JoinedStockOrders?JoinedStockOrders:StockOrders 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false))  
                return list
            }, 
            StockRequestsData(){ 
                const StockRequests = this.StockRequests 
                const JoinedStockRequests = this.JoinedStockRequests
                const items = JoinedStockRequests?JoinedStockRequests:StockRequests 
                if(!items){return null} 
                let list = items?.filter(item=>!item.canceled)
                list?.sort(this.MBS.actions.dynamicSort("created_at_server",false))    
                return list
            }, 
            StockDraftsData(){ 
                const StockDrafts = this.StockDrafts 
                const JoinedStockDrafts = this.JoinedStockDrafts
                const items = JoinedStockDrafts?JoinedStockDrafts:StockDrafts 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false))  
                return list
            }, 
            InvoiceData(){ 
                const data = this.QuotationsAndInvoices 
                const joinedData = this.JoinedQuotationsAndInvoices
                const items = joinedData?joinedData:data 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false)) 
                console.log(data,'.........InvoiceData');
                return list
            }, 
            StockDocumentTypeData(){
                const invoices = this.InvoiceData
                const requests = this.StockRequestsData
                const drafts = this.StockDraftsData
                const type_key = this.input?.receive_stock_type_key
                let data = requests
                if (type_key == "drafts") {
                    data = drafts
                }else if (type_key == "request") {
                    data = requests
                }else if (type_key == "invoices") {
                    data = invoices
                }else if (type_key == "purchase_order") {
                    data = requests
                }else if (type_key == "returned_stock") {
                    data = requests
                }  
                console.log(data,"data-----------------+++");
                
                return data 
            }, 
            SelectedDocument(){
                const documents = this.StockDocumentTypeData 
                const document_key = this.input?.document_key
                const item = documents?.find(item=>item.key == document_key) 
                return item 
            },
            SuppliersData(){   
                let items = this.JoinedSuppliers?this.JoinedSuppliers:this.Suppliers  
                return items  
            },  
            PaymentMethodsData(){
                let items = []
                let DefaultBillAccount = this.DefaultBillAccount  
                let DefaultPaymentMethod = this.DefaultPaymentMethod 
                let PaymentMethods= this.JoinedPaymentMethods?this.JoinedPaymentMethods:this.PaymentMethods
                if(DefaultBillAccount){
                    items = [...DefaultBillAccount]
                }
                if(DefaultPaymentMethod){
                    items= [
                        ...items,
                        ...DefaultPaymentMethod
                    ]
                } 
                if(PaymentMethods){
                    items= [
                        ...items,
                        ...PaymentMethods
                    ]
                } 
                return items
            }, 
            
            SelectedStockOption(){
                const options = this.StockReceiveTypes 
                const type_key = this.input?.receive_stock_type_key
                const item = options?.find(item=>item.key == type_key) 
                return item 
            },
            BillTerms(){
                return this.$store.getters.getBillTerms
            }, 
            Selectors(){ 
                let Outlets = this.StockOutletsData 
                let ToOutlets = this.ToOutlets 
                let Items = this.ItemsData  
                let ItemCategories = this.ItemCategories 
                let StockReceiveTypes = this.StockReceiveTypes
                let StockReceiveOptions = this.StockReceiveOptions
                let StockDocumentTypeData = this.StockDocumentTypeData 
                let Suppliers = this.SuppliersData 
                let SupplierCategories = this.SupplierCategoriesData
                let PaymentMethods = this.PaymentMethodsData 
                let BillTerms = this.BillTerms 
                
                return{
                    Outlets: Outlets,
                    ToOutlets: ToOutlets,
                    Items: Items,
                    ItemCategories: ItemCategories, 
                    StockReceiveTypes: StockReceiveTypes, 
                    StockReceiveOptions: StockReceiveOptions, 
                    StockDocumentTypeData: StockDocumentTypeData, 
                    Suppliers: Suppliers, 
                    SupplierCategories:SupplierCategories,
                    PaymentMethods: PaymentMethods, 
                    BillTerms:BillTerms, 
                }
            }, 
            ReceiveOptionField(){
                return [{
                    type:"autocomplete",value:"receive_stock_type_key",label:"Select Type",label_top:"Document type to process the incoming stock*", 
                    select:{
                        name:'StockReceiveTypes',
                        value:'key',
                        text:'name'
                    },
                    search:{
                        filter:(item, queryText, itemText) => { 
                            let index = (a,b)=>{
                                if(!a||!b){return false}
                                a = ""+a; b = ""+b
                                return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                            } 
                            let first = index(itemText,queryText)
                            let second = item?index(item.code,queryText):false
                            if(!item){return first} 
                            return first || second 
                        },
                        item_icon:{
                            name:'',
                            tile:true,
                            array:true,
                            size:'25'
                        },
                        item_title:['name'],
                        item_subtitle:['description',]
                    }, 
                    // onstart:{data_array:"ToOutlets",index:0},
                    required:true,autofocus:false,sm:12,md:12
                }]
            },
            DocumentReceiptsField(){
                return [{
                    type:"autocomplete",value:"document_key",label:"Select Document",label_top:"Document Receipt*", 
                    select:{
                        name:'StockDocumentTypeData',
                        value:'key',
                        text:'created_at_'
                    },
                    search:{
                        filter:(item, queryText, itemText) => { 
                            let index = (a,b)=>{
                                if(!a||!b){return false}
                                a = ""+a; b = ""+b
                                return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                            } 
                            let first = index(itemText,queryText)
                            let second = item?index(item.code,queryText):false
                            if(!item){return first} 
                            return first || second 
                        },
                        item_icon:{
                            name:'',
                            tile:true,
                            array:true,
                            size:'25'
                        },
                        double_item_title:[
                            {prefix:"Data: ", value:'created_at_',right_space:true},
                            {value:'total_price_',prefix_value:"Total Cost: ",suffix_value:"",bold:true }
                        ],
                        item_subtitle:[
                            {prefix:"Stock = ", value:(this_,item)=>{
                                return "("+item.type_name+") From: "+item.deliver_from_name+" To: "+item.deliver_to_name
                            }},
                            {prefix:"", value:(this_,item)=>{
                                return "Option: "+item.option_name+" | Items: "+item.total_quantity_
                            }}, 
                            // {prefix:"items: ", value:"total_quantity_"},
                            {prefix:"Created by: ", value:"user_name"},
                        ]
                    }, 
                    // onstart:{data_array:"ToOutlets",index:0},
                    required:true,autofocus:true,sm:12,md:12
                }]
            },
            HEADER_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon',color:"secondary",size:25,show:true},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"date",value:'created_at_',show:true},   
                    {id:0,name:"update date",value:'updated_at',show:false},   
                    {id:0,name:"Type",value:'type_name',show:false},   
                    {id:0,name:"code",align:"center",show:true},         
                    {id:0,name:"user",value:"user_name",show:false},     
                    {id:0,name:"From",value:"deliver_from",show:true},     
                    {id:0,name:"To",value:"deliver_to",show:true},       
                    {id:0,name:"items",value:'total_quantity_',align:'right',show:true},   
                    {id:0,name:"Payment",value:'payment_method_name',align:'right',show:false},   
                    {id:0,name:"Status",value:'payment_status',align:'right',show:false},   
                    {id:0,name:"Total Cost",value:'total_price_',align:'right',show:true},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Order",action:"view_order",icon:"mdi-eye"}, 
                        {name:"Archive Order",action:"archive_item",icon:"mdi-delete"},   
                    ]}, 
                ]
            },
        },
        methods:{ 
            RESET_ALL_DATA(rest_selected_items){ 
                let response ={
                    from:'RESET_ALL_DATA',
                    page:PAGE_NAME, 
                }
                return new Promise( async(resolve,reject)=>{
                    try {  
                        setTimeout( async () => { 
                            Object.assign(this.$data, this.$options.data())  
                            this.selected_outlet_code = this.to_outlet_code
                             
                            resolve({success:true})
                        }, 50);
                    } catch (error) {
                        response = {...response,error:error}
                        this.MBS.actions.error(response) 
                        reject(response)
                    } 
                })
            },
            SET_OUTLET(outlet_code){ 
                this.selected_outlet_code = outlet_code?outlet_code:this.to_outlet_code
                this.menu_outlet = false
            },
            async INVENTORY_STOCK_RECEIVE(payload){
                try {  
                    this.dialog_receive_stocks = true
                    this.receive_step = 1
                    this.receive_payload = payload
                   
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INVENTORY_STOCK_RECEIVE',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            async ADD_ITEM(item_key, item_code){
                try { 

                    console.log(item_key,item_code,); 
                    const settings = this.CompanySettings 
                    const activate_stock_level = settings?settings.activate_stock_level:null 

 
                    const outlet_code = this.stock_outlet_code
                    let quantity = null
                    let item_price = null 
                    let scales = this.Scales  
                    
                    const items = this.ItemsData 
                    const moment = this.MBS.date.moment
                    const selecting_list_key = moment?moment().valueOf():null

                    
                    
                    if (items) {
                        setTimeout(() => {
                            this.search_item=null 
                        }, 500);
                        let item_selected = items.find(item=>{
                            return  item_key?item.key == item_key:item.code == item_code
                        }) 
                        if (!item_selected) {
                            this.MBS.actions.dialog()
                            let isTimestamp = this.MBS.actions.isTimestamp(item_code)
                            if(isTimestamp){ 
                                console.log(item_code,'isTimestamp...')
                            }else{
                            }
                            setTimeout(() => {    
                                this.MBS.actions.dialogConfirmPassword({
                                    show:true,
                                    icon:mdiTagHidden,
                                    title:'ITEM NOT FOUND',
                                    text:"Item (" + item_code + ") not found. Please ensure that items are loaded and refreshed. Alternatively, you can use scanned barcode to add the item as new.",
                                    btnYes:"ADD AS NEW ITEM",
                                    btnNo:"REFRESH ITEMS",
                                    action:{
                                        code:PAGE_NAME+'=CREATE_AS_NEW_ITEM',
                                        item_code:item_code,
                                        silent_btn_no:true,
                                        phone_number_start:true,
                                        all_users:true,
                                        get_access:{
                                            permission_type:"action", 
                                            permission_to:"write", 
                                            action_name:DATA.ITEMS.ITEMS.names
                                        }
                                    }
                                }) 
                            }, 500); 
                            return 
                        } 
                        
                        //check stock level
                        if (activate_stock_level) {
                            
                            let stock_settings = await this.MBS.actions.CHECK_ITEM_STOCK_SETTINGS({
                                item:item_selected,
                                outlet_code:outlet_code,
                                notify:false
                            })

                            // console.log(stock_settings,'stock_settings-*---------------****');
                            
  
                            let allow_sell = stock_settings?stock_settings.allow_sell:null 
                            let stop_selling_level = stock_settings?stock_settings.stop_selling_level:null 
                            let quantity = stock_settings?stock_settings.quantity:null 
                            let stop_sale = quantity <= stop_selling_level?true:false
                            if (!allow_sell && stop_sale) {
                                await this.MBS.actions.CHECK_ITEM_STOCK_SETTINGS({
                                    item:item_selected,
                                    outlet_code:outlet_code,
                                    notify:true
                                })
                                return
                            } 
                        }


                        /// if array
                        let newItem = {
                            ...item_selected,  
                            quantity:quantity?quantity:1,
                        }

                       
                        console.log(newItem,'newItem......');

                       
                        this.MBS.events.$emit("ADD_STOCK_RECEIVE_SELECTED_ITEMS",{
                            item_key:item_key,
                            item_code:item_code,  
                            selected_item:newItem,
                        }) 
                        return 
                    }
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            CONFIRM_CLEAR_SELECTED_ITEMS(){
                try {    
                    
                    let mbs_text = this.MBS.text.item_action("Selected Items","Clear") 
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-delete",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=CLEAR-SELECTED-ITEMS', 
                            show_response:true
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_CLEAR_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CLEAR_RECEIVE_SELECTED_ITEMS(show_response){
                try {   
                    this.MBS.events.$emit("CLEAR_RECEIVE_SELECTED_ITEMS",{show_response})  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CLEAR_RECEIVE_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            INITIALIZE_SELECTED_ITEMS(to_outlet_code){
                try {   
                    this.MBS.events.$emit("INITIALIZE_SELECTED_ITEMS",{to_outlet_code}) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'INITIALIZE_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CONFIRM_CANCELING_RECEIVE_STOCK(){
                try {     
                    let mbs_text = this.MBS.text.item_action("Receiving stock","Cancel") 
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true, 
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:"No",
                        action:{
                            code:PAGE_NAME+'=CANCEL-RECEIVE-STOCK', 
                            show_response:true
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_CANCELING_RECEIVE_STOCK',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CANCEL_RECEIVE_STOCK(){
                try {   
                    // this.dialog_receive_stocks = false
                    this.RESET_ALL_DATA()
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CANCEL_RECEIVE_STOCK',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CLOSE_DIALOGS(){
                try { 
                    this.dialog_receive_stocks = false 
                    this.dialog_receiving_type = false 
                    this.dialog_receive_select_items = false 
                    this.dialog_receive_stocks = false 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CLOSE_DIALOGS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            NEXT_STEP(step,input){
                try {   
                    //----------------[STEP1 -> 3]
                    if ( this.receive_step==1 && step==2 && this.input?.receive_stock_type_key == 'new_record') {
                        this.receive_step = 3 
                        this.CLEAR_RECEIVE_SELECTED_ITEMS()
                        const payload = this.receive_payload
                        if (payload?.item_key !=undefined || payload?.item_code !=undefined  ) { 
                            setTimeout(() => {
                                this.ADD_ITEM(payload.item_key,payload.item_code) 
                            }, 100);
                        }  
                        
                    }
                    //----------------[STEP3 -> 1]
                    else if ( this.receive_step==3 && step==2 && this.input?.receive_stock_type_key == 'new_record') {
                        this.receive_step = 1
                    }
                    //----------------[STEP2 -> 3]
                    else if ( this.receive_step==2 && step==3) {
                        this.edit_selected_items = true
                        this.CLEAR_RECEIVE_SELECTED_ITEMS()
                        this.receive_step = step  
                        const receive_stock_type_key = input?.receive_stock_type_key
                        const selected_document = this.SelectedDocument
                        const order_type = selected_document?.order_type 
                        const items = selected_document?.items
                        const to_outlet_code = selected_document?.to_outlet_code
                        this.selected_outlet_code = to_outlet_code 
                         
                        if(receive_stock_type_key=="requests"){ 
                            this.edit_selected_items = false 
                        }else{
                            
                        }
                        
                        setTimeout(() => {
                            this.MBS.events.$emit("ADD_STOCK_RECEIVE_SELECTED_ITEMS",{
                                selected_items:items
                            }) 
                        }, 100); 
                         
                    }
                    //----------------[STEP2 -> 4]
                    else if ( step==4) { 
                        this.disabled_fields = []
                        const selected_document = this.SelectedDocument
                        this.input_receive = {}
                        if (selected_document) {
                            this.input_receive = {...selected_document}
                        }
                        const order_type = selected_document?.order_type
                        const receive_stock_type_key = input?.receive_stock_type_key 
                        const selected_outlet_code = this.selected_outlet_code 
                        this.input_receive.to_outlet_code = selected_outlet_code
                        this.input_receive.receive_stock_type_key = receive_stock_type_key


                        if (receive_stock_type_key == "drafts") {
                            const code = selected_document?.code
                            const receive_from_type = selected_document?.receive_from_type
                            const from_outlet_code = selected_document?.from_outlet_code
                            const to_outlet_code = selected_document?.to_outlet_code
                            const items = selected_document?.items
                            const bill_due_date = selected_document?.bill_due_date
                            const received_date = selected_document?.received_date
                            const description = selected_document?.description
                            if (order_type == "stock_receive") {
                                this.disabled_fields = ["receive_from_type","from_outlet_code","to_outlet_code"]
                                this.input_receive = {
                                    ...this.input_receive,
                                    code,receive_from_type,from_outlet_code,
                                    to_outlet_code,bill_due_date,received_date,
                                    description
                                }
                            } 
                        }else if(receive_stock_type_key=="requests"){
                            if (order_type == "stock_receive") {
                                this.disabled_fields = ["code","receive_from_type","from_outlet_code","to_outlet_code",'supplier_key',
                                    "received_date","payment_method_key","bill_terms","bill_due_date"
                                ]  
                            } 
                        }else if(receive_stock_type_key=="invoices"){
                            if (order_type == "stock_receive") {
                                this.disabled_fields = ["receive_from_type","from_outlet_code","to_outlet_code"] 
                            } 
                        }else if(receive_stock_type_key=="purchase_order"){
                            if (order_type == "stock_receive") {
                                this.disabled_fields = ["receive_from_type","from_outlet_code","to_outlet_code"] 
                            } 
                        }else if(receive_stock_type_key=="transfers"){
                            if (order_type == "stock_receive") {
                                this.disabled_fields = ["receive_from_type","from_outlet_code","to_outlet_code"] 
                            } 
                        }else if(receive_stock_type_key=="returned_stock"){
                            if (order_type == "stock_receive") {
                                this.disabled_fields = ["receive_from_type","from_outlet_code","to_outlet_code"] 
                            } 
                        }
                        setTimeout(() => {
                            this.receive_step = step 
                        }, 10);

                         
                    }
                    
                    else{
                        this.receive_step = step 
                    }
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'NEXT_STEP',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            
            ON_SUBMIT_SOCK_RECEIVE(option){ 
                try { 
                    this.menu_transfer_option = false
                    this.receive_option = option  
                    this.$refs.ref_btn_receive_stock.$el.click();
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_SUBMIT_SOCK_RECEIVE',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            CONFIRM_SUBMIT_STOCK_RECEIVE(input,receive_option){
                try {  
                    const ud = this.ud
                    const uid = ud?.uid
                    const company = this.SELECTED_COMPANY
                    const company_key = company?.company_key
                    const selected_document = this.SelectedDocument
                    let selected_document_key = selected_document?.key
                    let selected_document_type = selected_document?.receive_option
                    const moment = this.MBS.date.moment
                    const key = moment?moment().valueOf():null

                    const code = input?.code?input?.code:null
                    const receive_from_type = input?.receive_from_type?input?.receive_from_type:null
                    const from_outlet_code = input?.from_outlet_code?input?.from_outlet_code:null
                    const to_outlet_code = input?.to_outlet_code?input?.to_outlet_code:null
                    const supplier_key = input?.supplier_key?input?.supplier_key:null
                    const received_date = input?.received_date?input?.received_date:null
                    const receive_stock_type_key = input?.receive_stock_type_key?input?.receive_stock_type_key:null
                    const payment_method_key = input?.payment_method_key?input?.payment_method_key:null

                    const bill_due_date = input?.bill_due_date?input?.bill_due_date:null
                    const bill_terms = input?.bill_terms?input?.bill_terms:null
                    const description = input?.description?input?.description:null
                    const selected_items = this.selected_items
                    let dialog = this.MBS.actions.dialog
                    let items = []
                    let mbs_text = null
                    let error_text = null
                    selected_items?.forEach(item => {
                        items.push({
                            item_key:item._key,
                            item_code:item._code,
                            item_name:item.name,
                            item_cost_price:item.cost_price,
                            quantity:item.quantity, 
                            
                        })
                        
                    });
                    if (receive_stock_type_key == "new_record") {
                        selected_document_key = code
                    }
                    const data = {
                        order_type:DATA.ITEMS.STOCK_RECEIVES.value,
                        code,receive_from_type,from_outlet_code,
                        to_outlet_code,supplier_key,received_date,
                        receive_stock_type_key,payment_method_key,bill_due_date,bill_terms,
                        description,items,
                        created_uid:uid,
                        company_key,
                        local_created_at:key,
                        receive_option,
                        selected_document_key,
                        selected_document_type
                    }
                    if (from_outlet_code == to_outlet_code) {
                        error_text = 'Deliver to outlet should be different from Received from outlet. '
                    }

                    if (receive_option == "send_for_approval") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock Receive for approval","Send") 
                    }else if (receive_option == "direct_receive") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock","Direct Receive") 
                    }else if (receive_option == "save_draft") {
                        mbs_text = this.MBS.text.item_action("Draft","Save") 
                    }else if (receive_option == "approve_request") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Request","Approve") 
                    }else if (receive_option == "cancel_request") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Request","Cancel") 
                    }else{
                        error_text = "Something went wrong. Please try again."
                    } 

                    if (error_text) {
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            icon:"mdi-alert",
                            title:"ERROR",
                            text:error_text,
                            btnYes:"OKAY", 
                        })  
                        return 
                    }
                    console.log(input,'input..............');
                    console.log(data,'data..............XXX');
 
                    dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-transfer",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=SUBMIT-RECEIVE-STOCK', 
                            data,
                            phone_number_start:true,
                            all_users:true,
                            get_access:{
                                permission_type:"action", 
                                permission_to:"inventory", 
                                action_name:DATA.ITEMS.STOCK_TRANSFERS.names
                            }
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_SUBMIT_STOCK_RECEIVE',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            SUBMIT_STOCK_RECEIVE(order,action){
                try {  
                    const order_code = order?.code
                    const uid = action?.ud?.uid
                    const receive_option = order?.receive_option 

                    const path_map = {
                        "send_for_approval":{
                            path:this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order_code,true),
                            action:"Sending",
                            name:"For Approval"
                        },
                        "cancel_request":{
                            path:this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order_code,true),
                            action:"Canceling",
                            name:"Request",

                        },
                        "save_draft":{
                            path:this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_drafts+order_code,true),
                            action:"Saving",
                            name:"Draft",

                        }
                    }
                    const requests = {
                        "direct_receive":{
                            action:"Direct Receiving",
                            name:"Stock"
                        },
                        "approve_request":{
                            action:"Approving",
                            name:"Stock Request"
                        }, 
                    }

                    if (uid) {
                        order.logged_uid = order.created_uid
                        order.created_uid = uid
                    }
                    if (requests[receive_option]) {
                        this.inputLoading = true 
                        this.MBS.actions.progressDialog({
                            show:true,
                            fixed:false,
                            title:"Updating"
                        }) 
                        this.MBS.actions.POST_REQUEST({
                            action:this.VALUE_ITEM,
                            path:"receiveStock",
                            data:order,
                            us:this.us
                        }) 
                        .then(res=>{ 
                            this.inputLoading = false
                            this.dialog_receive_select_items = false
                            this.dialog_receive_stocks = false
                            this.MBS.actions.progressDialog() 
                            this.CLEAR_RECEIVE_SELECTED_ITEMS()
                            this.CLOSE_DIALOGS()
                            this.RESET_ALL_DATA()
                            let mbs_text = this.MBS.text.item_action_success(requests[receive_option]?.name,requests[receive_option]?.action)
                            this.MBS.actions.dialog({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes, 
                            })   
                            console.log(res,'re..................s');
                        }).catch(error=>{
                            console.log(error,'err..................');
                            this.MBS.actions.progressDialog() 
                            this.MBS.actions.error({
                                error:error,
                                from:'SUBMIT_ORDER',
                                page:PAGE_NAME, 
                            })  
                            this.inputLoading = false
                            this.MBS.actions.progressDialog() 
                            let mbs_text = this.MBS.text.item_action_fail(requests[receive_option]?.name,requests[receive_option]?.action)
                            this.MBS.actions.dialog({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes, 
                            }) 
                        })
                    }else if(path_map[receive_option]){ 
                        let path = path_map[receive_option].path    
                        let updating_order = {...order}
                        if (receive_option == "cancel_request") {
                            updating_order = {canceled:true}
                        }  
                        this.inputLoading = true
                        this.MBS.actions.progressDialog({
                            show:true,
                            title:"Uploading..",
                        }) 
                        this.$store.dispatch("fi_update",{
                            action:DATA.ITEMS.STOCK_ORDERS.values,
                            data:updating_order,
                            path:path
                        })
                        .then(res=>{
                            // console.log(res,'re..................');
                            // if (order.selected_document_type) {
                            //     const source_path = {
                            //         "save_draft": this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_drafts+order.selected_document_key,true),
                            //         "purchase_order": this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order.selected_document_key,true),
                            //         "transfers": this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order.selected_document_key,true),
                            //         "invoices": this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_invoices+order.selected_document_key,true),
                            //     };
                            //     return this.$store.dispatch("fi_delete",{path:source_path[order.selected_document_type],action:DATA.ITEMS.STOCKS.value})
                            // }
                            return  res 
                        })
                        .then(res=>{
                            this.inputLoading = false
                            this.dialog_receive_select_items = false
                            this.dialog_receive_stocks = false
                            this.MBS.actions.progressDialog() 
                            this.CLEAR_RECEIVE_SELECTED_ITEMS()
                            let mbs_text = this.MBS.text.item_action_success(path_map[receive_option]?.name,path_map[receive_option]?.action)
                            this.MBS.actions.dialog({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes, 
                            })   
                            console.log(res,'re2..................s');
                             
                        }).catch(error=>{
                            console.log(error,'err..................');
                            this.MBS.actions.progressDialog() 
                            this.MBS.actions.error({
                                error:error,
                                from:'SUBMIT_ORDER',
                                page:PAGE_NAME, 
                            })  
                            this.inputLoading = false
                            this.MBS.actions.progressDialog() 
                            let mbs_text = this.MBS.text.item_action_fail(path_map[receive_option]?.name,path_map[receive_option]?.action)
                            this.MBS.actions.dialog({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes, 
                            })  
                        }) 

                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SUBMIT_STOCK_RECEIVE',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            
            

            //---------------[MAIN FUNCTIONS]------------   
            DIALOG_YES(action){ 
                try {
                    if (action.code) { 
                        if (action.code ===PAGE_NAME+'=CLEAR-SELECTED-ITEMS') {
                            if (action.YES) {
                                this.CLEAR_RECEIVE_SELECTED_ITEMS(action.show_response)
                            } else {
                                
                            }
                        } if (action.code ===PAGE_NAME+'=SUBMIT-RECEIVE-STOCK') {
                            if (action.YES) {
                                this.SUBMIT_STOCK_RECEIVE(action.data,action)
                            } else {
                                
                            }
                        }if (action.code ===PAGE_NAME+'=CANCEL-RECEIVE-STOCK') {
                            if (action.YES) {
                                this.CANCEL_RECEIVE_STOCK()
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            ON_QR_SCAN(code){
                try {
                    if (code) {  
                        
                        let size = this.MBS.actions.SIZE(code)
                        if (size<3) { 
                        }else{  
                             
                        }
                    }
                } catch (error) {
                    console.log(error,'.............................');
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_QR_SCAN',
                        page:PAGE_NAME, 
                    })  
                } 
            },
            MBS_KEYBOARD(key){ 
                let focused_field = this.focused_field
                const field_value = focused_field?focused_field.value:null

                const ref_inputs = this.$refs
                if (key ) {
                    let value = key.value 
                    if (field_value) { 
                        if (field_value == "current_selected_item_quantity") {
                            if (value=="BACK_SPACE") {
                                this.current_selected_item.quantity = (""+this.current_selected_item.quantity).slice(0,-1)
                            } else {
                                this.current_selected_item.quantity =this.current_selected_item.quantity+""+value 
                            }
                        }else if (field_value == "current_selected_item_discount") {
                            if (value=="BACK_SPACE") {
                                this.current_selected_item.discount = (""+this.current_selected_item.discount).slice(0,-1)
                            } else {
                                this.current_selected_item.discount =this.current_selected_item.discount+""+value 
                            }
                        }else{
                            if(!this.input){this.input={}}
                            if (value=="BACK_SPACE") {
                                this.input[field_value] =(this.input[field_value]?this.input[field_value]+'':'').slice(0,-1)
                            }else{
                                this.input[field_value] =(this.input[field_value]?this.input[field_value]:'')+value
                                console.log((this.input[field_value]?this.input[field_value]:'')+value,'****......');
                            }
                            setTimeout(() => {
                                this.input = {...this.input}
                            }, 1);

                            console.log(this.input,'input......');
                            console.log(value,'value......');
                        }
                        
                    }
                }
            }, 
        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);  
                this.MBS.events.$off('ON_QR_SCAN', this.ON_QR_SCAN);  
                this.MBS.events.$off('MBS_KEYBOARD', this.MBS_KEYBOARD);        
                this.MBS.events.$off('INVENTORY_STOCK_RECEIVE', this.INVENTORY_STOCK_RECEIVE);        
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{   
            input_receive(value){
                // this.selected_items = value?.selected_items 
            }, 
            search_item(value){ 
                if (value) {
                    this.ADD_ITEM(value) 
                }
            },
            to_outlet_code(code){
                this.SET_OUTLET(code)
            },
            // selected_outlet_code(code){
            //     this.INITIALIZE_SELECTED_ITEMS(code)
            // }
        } 
    }
</script>
<style>
    .selected {
        background-color: #a8dadc;
    }
    .checked {
        background-color: #dadada;
    }
    
</style> 